// Get All Licenses
export const GET_ALL_LICENSES_REQUEST = "GET_ALL_LICENSES_REQUEST";
export const GET_ALL_LICENSES_SUCCESS = "GET_ALL_LICENSES_SUCCESS";
export const GET_ALL_LICENSES_FAIL = "GET_ALL_LICENSES_FAIL";

// Get License by ID
export const GET_LICENSE_BY_ID_REQUEST = "GET_LICENSE_BY_ID_REQUEST";
export const GET_LICENSE_BY_ID_SUCCESS = "GET_LICENSE_BY_ID_SUCCESS";
export const GET_LICENSE_BY_ID_FAIL = "GET_LICENSE_BY_ID_FAIL";

// Get All Active Licenses
export const GET_ALL_ACTIVE_LICENSES_REQUEST = "GET_ALL_ACTIVE_LICENSES_REQUEST";
export const GET_ALL_ACTIVE_LICENSES_SUCCESS = "GET_ALL_ACTIVE_LICENSES_SUCCESS";
export const GET_ALL_ACTIVE_LICENSES_FAIL = "GET_ALL_ACTIVE_LICENSES_FAIL";

// Add License
export const ADD_LICENSE_REQUEST = "ADD_LICENSE_REQUEST";
export const ADD_LICENSE_SUCCESS = "ADD_LICENSE_SUCCESS";
export const ADD_LICENSE_FAIL = "ADD_LICENSE_FAIL";

// Update License Status
export const UPDATE_LICENSE_STATUS_REQUEST = "UPDATE_LICENSE_STATUS_REQUEST";
export const UPDATE_LICENSE_STATUS_SUCCESS = "UPDATE_LICENSE_STATUS_SUCCESS";
export const UPDATE_LICENSE_STATUS_FAIL = "UPDATE_LICENSE_STATUS_FAIL";